export const APP_TITLE = 'emagine';

export function buildPageTitle(moduleName: string): string {
	return `${APP_TITLE} · ${moduleName}`;
}
